import React from 'react'
import { Button, Modal, Form, Radio } from 'semantic-ui-react'

const ReissueModal = ({ open, close, value, handleChange, handleSuccess }) => (
  <Modal size="mini" open={open} onClose={close}>
    <Modal.Header>청구서 결재라인 선택</Modal.Header>
    <Modal.Content>
      <Form>
        <Form.Field>
          <Radio
            label='현재 결재라인으로 재발행'
            name='radioGroup'
            value='current'
            checked={ value === 'current' }
            onChange={handleChange}
          />
        </Form.Field>
        <Form.Field>
          <Radio
            label='다음 결재라인으로 재발행'
            name='radioGroup'
            value='setting'
            checked={ value === 'setting' }
            onChange={handleChange}
          />
        </Form.Field>
      </Form>
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={close}>닫기</Button>
      <Button positive content='재발행' onClick={handleSuccess}/>
    </Modal.Actions>
  </Modal>
)
export default ReissueModal